import React from 'react';
import { Link } from 'react-router-dom';
import { ShieldCheckIcon } from '@heroicons/react/24/outline';
import { ROUTES } from '../../constants/routes';

export const PublicHeader: React.FC = () => {
    // Custom scroll handler
    const handleScroll = (e: React.MouseEvent<HTMLAnchorElement>, id: string) => {
        // If we are on the home page, we want a smooth scroll
        if (window.location.pathname === '/') {
            e.preventDefault();
            const element = document.getElementById(id);
            if (element) {
                element.scrollIntoView({ behavior: 'smooth' });
                // Update URL without reload
                window.history.pushState(null, '', `/#${id}`);
            }
        }
        // If we are not on home page, normal Link behavior (navigation) will occur
        // and LandingPage useEffect will handle the scroll on load
    };

    return (
        <nav className="fixed w-full z-50 bg-background-dark/80 backdrop-blur-md border-b border-white/10">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="flex items-center justify-between h-20">
                    <Link to="/" className="flex items-center gap-2" onClick={() => window.scrollTo(0, 0)}>
                        <div className="size-8 text-brand">
                            <ShieldCheckIcon className="w-full h-full" />
                        </div>
                        <span className="text-xl font-bold font-display tracking-tight text-white">FortifyTech</span>
                    </Link>
                    <div className="hidden md:block">
                        <div className="ml-10 flex items-baseline space-x-8">
                            <Link to="/#home" onClick={(e) => handleScroll(e, 'home')} className="hover:text-brand transition-colors px-3 py-2 rounded-md text-sm font-medium text-white">Inicio</Link>
                            <Link to="/#services" onClick={(e) => handleScroll(e, 'services')} className="hover:text-brand transition-colors px-3 py-2 rounded-md text-sm font-medium text-white">Servicios</Link>
                            <Link to="/#software" onClick={(e) => handleScroll(e, 'software')} className="hover:text-brand transition-colors px-3 py-2 rounded-md text-sm font-medium text-white">Software</Link>
                            <Link to="/#about" onClick={(e) => handleScroll(e, 'about')} className="hover:text-brand transition-colors px-3 py-2 rounded-md text-sm font-medium text-white">Nosotros</Link>
                            <Link to="/#contact" onClick={(e) => handleScroll(e, 'contact')} className="hover:text-brand transition-colors px-3 py-2 rounded-md text-sm font-medium text-white">Contacto</Link>
                            <Link to={ROUTES.LOGIN} className="bg-brand hover:bg-brand/90 text-white px-4 py-2 rounded-lg text-sm font-bold transition-all shadow-[0_0_20px_-5px_rgba(19,91,236,0.3)]">
                                Iniciar Sesión
                            </Link>
                        </div>
                    </div>
                    <div className="-mr-2 flex md:hidden">
                        <button type="button" className="bg-gray-800 inline-flex items-center justify-center p-2 rounded-md text-gray-400 hover:text-white hover:bg-gray-700 focus:outline-none" aria-controls="mobile-menu" aria-expanded="false">
                            <span className="sr-only">Open main menu</span>
                            <svg className="block h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16M4 18h16" />
                            </svg>
                        </button>
                    </div>
                </div>
            </div>
        </nav>
    );
};
